import { WorkspaceAdapters, WorkspaceProvider } from '@xometry/workspace';
import { AccessRequestLink } from 'components/shared/AccessRequestLink';
import { UserView } from 'components/UI/UserView';
import React, { FC, PropsWithChildren } from 'react';
import { routes } from 'routes';

import { erpAsyncJobsAdapter } from './erpAsyncJobsAdapter';
import { erpPermissionsAdapter } from './erpPermissionsAdapter';
import { erpUrlStateAdapter } from './erpUrlStateAdapter';
import { erpWorkspaceDataSource } from './erpWorkspaceDataSource';
import { erpWorkspacePresetsSource } from './erpWorkspacePresetsSource';

/** ERP's implementation of the Workspace adapters. Must sit below Apollo, the root store and the router. */
const adapters: WorkspaceAdapters = {
  dataSource: erpWorkspaceDataSource,
  presets: erpWorkspacePresetsSource,
  permissions: erpPermissionsAdapter,
  asyncJobs: erpAsyncJobsAdapter,
  urlState: erpUrlStateAdapter,
  renderAccessRequestLink: ({ group, action }) => <AccessRequestLink group={group} action={action} />,
  renderUserOption: ({ label, value, imageUrl }) => <UserView user={{ id: value, name: label, imageUrl }} />,
  queryLanguageHelpUrl: routes.external.workspacesQuerySpec(),
};

export const WorkspaceAppProvider: FC<PropsWithChildren> = ({ children }) => (
  <WorkspaceProvider adapters={adapters}>{children}</WorkspaceProvider>
);
